import React from 'react';
import { IconButton, Tooltip, type SxProps, type Theme } from '@mui/material';
import {
  ContentCopy as ContentCopyIcon,
  Check as CheckIcon,
} from '@mui/icons-material';
import { useClipboard } from '../hooks/useClipboard';

interface CopyIconButtonProps {
  text: string;
  tooltip?: string;
  size?: 'small' | 'medium';
  iconSize?: number;
  sx?: SxProps<Theme>;
}

const CopyIconButton: React.FC<CopyIconButtonProps> = ({
  text,
  tooltip = 'Copy',
  size = 'small',
  iconSize,
  sx,
}) => {
  const { copied, copy } = useClipboard();

  return (
    <Tooltip title={copied ? 'Copied!' : tooltip}>
      <IconButton
        size={size}
        onClick={(e) => {
          e.stopPropagation();
          copy(text);
        }}
        sx={sx}
      >
        {copied
          ? <CheckIcon sx={iconSize ? { fontSize: iconSize } : undefined} fontSize={iconSize ? undefined : 'small'} />
          : <ContentCopyIcon sx={iconSize ? { fontSize: iconSize } : undefined} fontSize={iconSize ? undefined : 'small'} />
        }
      </IconButton>
    </Tooltip>
  );
};

export default CopyIconButton;
